module.exports = __webpack_public_path__ + "static/img/about-img-01.ee22a71.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-img-01.jpeg
// module id = IQnW
// module chunks = 0